module.exports = __webpack_public_path__ + "img/trademarkingDateImg.fe24f4fa.png";